import React, { useState } from 'react';
import ProfileModal from './ProfileModal';

const SidebarProfile = ({ user }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Fallback defaults
    const displayName = user?.name || 'User';
    const displayRole = user?.designation || 'Member';

    return (
        <>
            <div
                className="flex items-center space-x-3 p-3.5 bg-white/5 rounded-xl cursor-pointer hover:bg-white/10 transition-all duration-200 border border-white/10 group"
                onClick={() => setIsModalOpen(true)}
            >
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center text-white text-lg font-bold shadow-lg shrink-0 ring-2 ring-white/10 group-hover:ring-white/20 transition-all">
                    {user?.avatar_url || user?.photo_url ? (
                        <img src={user?.avatar_url || user?.photo_url} alt={displayName} className="w-full h-full object-cover rounded-full" />
                    ) : (
                        displayName.charAt(0).toUpperCase()
                    )}
                </div>
                <div className="overflow-hidden flex-1">
                    <h3 className="font-semibold text-white truncate text-sm">{displayName}</h3>
                    <p className="text-xs text-slate-400 font-medium truncate">{displayRole}</p>
                </div>
            </div>

            <ProfileModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                user={user}
            />
        </>
    );
};

export default SidebarProfile;
